module.exports = __webpack_public_path__ + "img/my0803.prt.b97da557.jpg";